import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { CEProductCustomizationPreview } from '../../bitf-customization-engine/CEProductCustomizationPreview';

const INIT_CLASS = 'product-customization-preview--initialized';
const reactRoots = new Map();

const cleanupRemovedElements = () => {
  for (const [element, root] of reactRoots.entries()) {
    if (!document.contains(element)) {
      root.unmount();
      reactRoots.delete(element);
    }
  }
};

const initPreviewApps = () => {
  console.log('initPreviewApps called');
  cleanupRemovedElements();

  console.log('Initializing product customization preview apps...');
  const productDataElements = document.querySelectorAll(
    `.CollectionMain .product-customization-preview:not(.${INIT_CLASS}), .Product__Gallery .product-customization-preview:not(.${INIT_CLASS}), .Section--bundle .product-customization-preview:not(.${INIT_CLASS})`,
  );

  productDataElements.forEach((element) => {
    const productHandle = element.getAttribute('data-product-handle');
    const productType = element.getAttribute('data-product-type').toLowerCase() || 'jersey';
    const competitionHandle = element.getAttribute('data-competition-handle');
    const storeName = element.getAttribute('data-store-name') || 'shared';
    const watchStoreChanges = element.getAttribute('data-watch-store-changes') === 'true';
    const country = element.getAttribute('data-country');
    const locale = element.getAttribute('data-language');
    const market = element.getAttribute('data-market');
    const isAlwaysVisible = element.getAttribute('data-is-always-visible') === 'true';
    const showProductImage = element.getAttribute('data-show-product-image') === 'true';
    const applyAllAddOns = element.getAttribute('data-apply-all-add-on') === 'true';
    const addCustomizationType = element.getAttribute('data-customization-type') === 'true' || false;
    let playerHandle = element.getAttribute('data-player-handle');
    let productVariant = element.getAttribute('data-product-variant');

    try {
      productVariant = productVariant ? JSON.parse(productVariant) : null;
    } catch (error) {
      productVariant = null;
    }

    let customizationType, customizationName, customizationNumber, playerSlug;
    if (addCustomizationType) {
      switch (productType) {
        case 'jersey':
          customizationType = 'player';
          playerSlug = element.getAttribute('data-player-slug');
          break;
        case 'shorts':
          customizationType = 'number';
          customizationNumber = element.getAttribute('data-player-number') || '';
          playerHandle = null;
          break;
        default:
          customizationType = 'name_and_number';
          customizationName = element.getAttribute('data-player-name') || '';
          customizationNumber = element.getAttribute('data-player-number') || '';
          playerHandle = null;
          break;
      }
      console.log('Customization type:', customizationType);
    }

    element.classList.add(INIT_CLASS);

    const root = createRoot(element);
    reactRoots.set(element, root);

    root.render(
      <StrictMode>
        <CEProductCustomizationPreview
          productHandle={productHandle}
          productType={productType}
          playerHandle={playerHandle}
          playerSlug={playerSlug}
          competitionHandle={competitionHandle}
          customizationHookConfig={{
            storeName,
            watchStoreChanges,
            localization: {
              country,
              locale,
              market,
            },
          }}
          isAlwaysVisible={true}
          showProductImage={showProductImage}
          applyAllAddOns={applyAllAddOns}
          customizationName={customizationName}
          customizationNumber={customizationNumber}
          customizationType={customizationType}
          productVariant={productVariant}
        />
      </StrictMode>,
    );
  });
};

document.addEventListener('collection:load-products', (event) => {
  console.log('Collection products loaded:', event);
  initPreviewApps();
});

initPreviewApps();
